export default {
  getSystemConfig: {
    method: 'get',
    url: '/admincp/system/config-data'
  },
  getSystemData: {
    method: 'get',
    url: '/admincp/system/system-data'
  }
}
